import moment from "moment";

import { parseDateModifier as dateRuleParser } from "../../forms/helper";

const findMinDate = (params: any) => {
    const {
        only_date_in_future: onlyDateInFuture,
        field_boi_date_in_future: fieldBoiDateInFuture,
        include_today_in_dates: includeToday,
        min_date: minDate,
        min_date_rule: minDateRule,
        field_boi_min_date_rule: fieldBoiMinDateRule,
        field_boi_min_start_date_rule: fieldBoiMinStartDateRule,
        field_boi_min_date_range_rule: fieldBoiMinDateRangeRule,
        field_boi_maximum_age: fieldBoiMaxAge
    } = params;
    const limits = [];
    const today = moment().startOf("day");
    const startOfYear = moment().startOf("year");

    onlyDateInFuture &&
        limits.push(today.clone().add(includeToday ? 0 : 1, "days"));
    fieldBoiDateInFuture && limits.push(today);
    minDate && limits.push(moment(minDate, "DD/MM/YYYY"));

    if (minDateRule) {
        const duration = moment.duration(dateRuleParser(minDateRule));
        const min = today.clone().add(duration);

        limits.push(min);
    }

    if (fieldBoiMinDateRule) {
        const duration = moment.duration(dateRuleParser(fieldBoiMinDateRule));
        const min = today.clone().add(duration);

        limits.push(min);
    }

    if (fieldBoiMinStartDateRule) {
        const duration = moment.duration(
            dateRuleParser(fieldBoiMinStartDateRule)
        );
        const min = today.clone().add(duration);

        limits.push(min);
    }

    if (
        fieldBoiMinDateRangeRule &&
        ((params.type === "boi_date_range" && params.value) ||
            params.type !== "boi_date_range")
    ) {
        const startDate = params.inputs
            ? moment(params.value[params.inputs[0].id], "YYYY-MM-DD")
            : today.clone();
        const duration = moment.duration(
            dateRuleParser(fieldBoiMinDateRangeRule)
        );
        const min = startDate
            .clone()
            .add(duration)
            .add(params.inputs ? -1 : 0, "days");

        min.isValid() && limits.push(min);
    }

    fieldBoiMaxAge &&
        limits.push(
            startOfYear.clone().add(-parseInt(fieldBoiMaxAge), "years")
        );
    return limits.length ? moment.max(limits).toDate() : null;
};

export default findMinDate;
